import { useTranslation } from 'react-i18next';

import { Placeholder } from './PlaceHolder';

const MovingExitLoopPlaceholder = (props: any) => {
  const { t } = useTranslation();

  return (
    <Placeholder
      placeholderText={t('An Exit Loop step must stay inside the loop it exits')}
      {...props}
    />
  );
};

export default MovingExitLoopPlaceholder;
